// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import {AudioSearchIndex} from '../search-index/audio-search-index.js'
import {HandwritingSearchIndex} from '../search-index/handwriting-search-index.js'
import {ImageSearchIndex} from '../search-index/image-search-index.js'
import {PDFSearchIndex} from '../search-index/pdfsearch-index.js'
import {TextSearchIndex} from '../search-index/text-search-index.js'

export enum IndexData {
  NONE = 0,
  TextSearchIndex = 1,
  ImageSearchIndex = 2,
  AudioSearchIndex = 3,
  PDFSearchIndex = 4,
  HandwritingSearchIndex = 5
}

export function unionToIndexData(
  type: IndexData,
  accessor: (
    obj: AudioSearchIndex | HandwritingSearchIndex | ImageSearchIndex | PDFSearchIndex | TextSearchIndex
  ) => AudioSearchIndex | HandwritingSearchIndex | ImageSearchIndex | PDFSearchIndex | TextSearchIndex | null
): AudioSearchIndex | HandwritingSearchIndex | ImageSearchIndex | PDFSearchIndex | TextSearchIndex | null {
  switch (IndexData[type]) {
    case 'NONE':
      return null
    case 'TextSearchIndex':
      return accessor(new TextSearchIndex())! as TextSearchIndex
    case 'ImageSearchIndex':
      return accessor(new ImageSearchIndex())! as ImageSearchIndex
    case 'AudioSearchIndex':
      return accessor(new AudioSearchIndex())! as AudioSearchIndex
    case 'PDFSearchIndex':
      return accessor(new PDFSearchIndex())! as PDFSearchIndex
    case 'HandwritingSearchIndex':
      return accessor(new HandwritingSearchIndex())! as HandwritingSearchIndex
    default:
      return null
  }
}

export function unionListToIndexData(
  type: IndexData,
  accessor: (
    index: number,
    obj: AudioSearchIndex | HandwritingSearchIndex | ImageSearchIndex | PDFSearchIndex | TextSearchIndex
  ) => AudioSearchIndex | HandwritingSearchIndex | ImageSearchIndex | PDFSearchIndex | TextSearchIndex | null,
  index: number
): AudioSearchIndex | HandwritingSearchIndex | ImageSearchIndex | PDFSearchIndex | TextSearchIndex | null {
  switch (IndexData[type]) {
    case 'NONE':
      return null
    case 'TextSearchIndex':
      return accessor(index, new TextSearchIndex())! as TextSearchIndex
    case 'ImageSearchIndex':
      return accessor(index, new ImageSearchIndex())! as ImageSearchIndex
    case 'AudioSearchIndex':
      return accessor(index, new AudioSearchIndex())! as AudioSearchIndex
    case 'PDFSearchIndex':
      return accessor(index, new PDFSearchIndex())! as PDFSearchIndex
    case 'HandwritingSearchIndex':
      return accessor(index, new HandwritingSearchIndex())! as HandwritingSearchIndex
    default:
      return null
  }
}
